import { Outlet, redirect } from 'react-router';
import type { LoaderFunctionArgs } from 'react-router';
import { route as stepNameRoute } from './step-name';
import { route as stepPhoneRoute } from './step-phone';
import { route as stepPartnerRoute } from './step-partner';
import { route as stepCategoryRoute } from './step-category';
import { route as stepScheduleRoute } from './step-schedule';
import { route as stepConfirmRoute } from './step-confirm';

function WizardLayout() {
  return (
    <div className="h-full flex flex-col min-h-0">
      <Outlet />
    </div>
  );
}

export const route = {
  path: 'open-inscriptions',
  element: <WizardLayout />,
  children: [
    {
      index: true,
      loader: ({ request }: LoaderFunctionArgs) => {
        const url = new URL(request.url);
        const base = url.pathname.endsWith('/')
          ? url.pathname.slice(0, -1)
          : url.pathname;
        return redirect(`${base}/nombre${url.search}`);
      },
    },
    stepNameRoute,
    stepPhoneRoute,
    stepPartnerRoute,
    stepCategoryRoute,
    stepScheduleRoute,
    stepConfirmRoute,
  ],
};
